import { RadioGroup } from "@design";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import type { Visibility } from "./useSpaceItems";

export function VisibilityChoice({
  value,
  onChange,
}: Readonly<{ value: Visibility; onChange: (value: Visibility) => void }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "settings.items.visibility" });
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="mb-2">
        <Text as="span" variant="body-sm" weight="semibold">
          {t("label")}
        </Text>
      </legend>
      <RadioGroup
        value={value}
        onChange={(v) => onChange(v as Visibility)}
        options={[
          { value: "private", label: t("private"), description: t("privateHint") },
          { value: "space", label: t("space"), description: t("spaceHint") },
        ]}
      />
    </fieldset>
  );
}
